"use client";
import { useLang } from "@/providers/langProvider";

const useIsRtl = () => {
  const lang = useLang();
  return lang === "ar";
};

export default useIsRtl;
